import { ScaleElement } from '@scale/base-element';

class ComparisonTable extends ScaleElement {
  static requiredRefs = ['table', 'mobile-nav'];

  #mq = window.matchMedia('(max-width: 749px)');

  setup() {
    this.#applyCardScheme();
    if (this.dataset.mobileLayout !== 'versus') return;
    this.#handleMq();
    this.#mq.addEventListener('change', () => this.#handleMq(), { signal: this.signal });
  }

  /**
   * In split style, each value column is a card with its own background.
   * Apply the card color scheme to every data cell (skip the label column).
   */
  #applyCardScheme() {
    const scheme = this.dataset.cardScheme;
    if (!scheme) return;
    const cells = this.ref('table').querySelectorAll('.ct-row > .ct-cell:not(:first-child)');
    for (const cell of cells) cell.classList.add(`color-${scheme}`);
  }

  #handleMq() {
    if (this.#mq.matches) {
      this.#activateMobile();
    } else {
      this.#deactivateMobile();
    }
  }

  #activateMobile() {
    const headerRow = this.ref('table').querySelector('.ct-row--header');
    if (!headerRow) return;

    const headerCells = [...headerRow.querySelectorAll('.ct-cell')];
    if (headerCells.length < 3) return;

    const highlightCol = parseInt(this.dataset.highlightCol, 10) || 2;
    const competitorIndexes = headerCells
      .map((_, i) => i + 1)
      .filter(i => i !== 1 && i !== highlightCol);

    if (competitorIndexes.length === 0) return;

    const nav = this.ref('mobile-nav');
    nav.innerHTML = '';
    nav.hidden = false;

    competitorIndexes.forEach((colIndex, idx) => {
      const label = headerCells[colIndex - 1]?.textContent.trim() || `Option ${colIndex}`;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ct-pill';
      btn.textContent = label;
      btn.dataset.col = colIndex;
      if (idx === 0) btn.classList.add('is-active');
      btn.addEventListener('click', () => this.#setActiveCol(colIndex, btn), { signal: this.signal });
      nav.appendChild(btn);
    });

    this.setAttribute('data-active-col', competitorIndexes[0]);
  }

  #setActiveCol(col, btn) {
    this.setAttribute('data-active-col', col);
    this.ref('mobile-nav').querySelectorAll('.ct-pill').forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
  }

  #deactivateMobile() {
    this.removeAttribute('data-active-col');
    const nav = this.ref('mobile-nav');
    nav.hidden = true;
    nav.innerHTML = '';
  }
}

if (!customElements.get('scale-comparison-table')) {
  customElements.define('scale-comparison-table', ComparisonTable);
}
